export default "__VITE_ASSET__CU8qmpOL__"